module.exports = __webpack_public_path__ + "static/media/3.cf970ce3.jpg";